import React, { useCallback } from 'react'
import { useOnNavigation } from '../src/hooks/useOnNavigation'
import SvgQuestionMark from './icons/SvgQuestionMark'
import { QuestionForm } from './QuestionForm'

interface HelpSubtitleProps {
	title: React.ReactNode
	askQuestion: React.ReactNode
}

export const HelpSubtitle: React.FunctionComponent<HelpSubtitleProps> = ({
	title,
	askQuestion,
}) => {
	const [showForm, setShowForm] = React.useState(false)
	const onCloseForm = useCallback(() => setShowForm(false), [])
	const toggleForm = useCallback(() => setShowForm((state) => !state), [])

	useOnNavigation(onCloseForm)

	return (
		<div className="helpSubtitle">
			<div className="helpSubtitle-in">
				<h3 className="helpSubtitle-title">{title}</h3>
				<button
					type="button"
					className="helpSubtitle-askQuestion"
					onClick={toggleForm}
				>
					<span className="helpSubtitle-askQuestion-icon">
						<SvgQuestionMark />
					</span>{' '}
					<span className="helpSubtitle-askQuestion-text">{askQuestion}</span>
				</button>
				{showForm && <QuestionForm onRequestClose={onCloseForm} />}
			</div>
		</div>
	)
}
